<template>
  <div v-loading.fullscreen.lock="loading" class="apply-index-box">
    <!-- 头部开始 -->
    <top-part></top-part>
    <!-- 头部结束 -->
    <!-- 签名弹出框 -->
    <div
      v-show="test"
      class="sign"
      style="position: fixed; top: 0; z-index: 9999; bottom: 0"
    >
      <signature @closePop="closePop" @saveImg="complete"></signature>
    </div>
    <!-- 签名弹出框结束 -->
    <div class="apply-content-box">
      <!-- form -->
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="80px !important"
        style="height: 100%; overflow: scroll"
      >
        <el-form-item
          label="提示"
          prop=""
          class="form-item"
          v-if="configuration.limitFlag == 1"
        >
          <div style="color: red">
            你可用申请次数{{ configuration.limitCount }}
          </div>
        </el-form-item>
        <!-- 姓名 -->
        <el-form-item label="姓名" prop="name" class="form-item">
          <div @click="openPersonnel">
            <span>{{ form.name }}</span>
            <van-icon name="arrow" class="right-icon" />
          </div>
        </el-form-item>
        <!-- 姓名结束 -->
        <!-- 科室选择 -->
        <el-form-item label="科室" class="form-item left-lable-box">
          <p>{{ form.deptName }}</p>
        </el-form-item>
        <!-- 科室选择结束 -->
        <!-- 性别 -->
        <el-form-item label="性别" class="form-item left-lable-box">
          <p>{{ transfromsex(form.gender) }}</p>
        </el-form-item>
        <!-- 性别结束 -->
        <!-- 年龄 -->
        <el-form-item label="年龄" class="form-item left-lable-box">
          <p>{{ form.age }}</p>
        </el-form-item>
        <!-- 年龄结束 -->
        <!-- 申请补助金额 -->
        <el-form-item
          label="申请补助金额"
          prop="applyMoney"
          class="form-item overflowText"
        >
          <el-input
            class="input input-sel"
            v-model="form.applyMoney"
            placeholder="0.00"
            :clearable="true"
            @input="changgeNumber()"
          ></el-input>
          <span>元</span>
        </el-form-item>
        <!-- 申请补助金额结束 -->

        <!--申请原因及现状  -->
        <el-form-item label="申请原因及现状" class="form-item overflowText">
          <el-input
            type="textarea"
            v-model="form.desc"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!--申请原因及现状结束  -->
        <!-- 资料盒子 -->
        <el-form-item label="资料上传" class="form-item left-lable-box">
          <!-- <van-uploader :max-size="500 * 1024" v-model="form.data" :after-read="afterRead"
            accept="image/*" multiple max-count="3" /> -->
          <van-uploader
            :max-size="maxSize * 1024 * 1024"
            @oversize="onOversize"
            accept="image/*"
            :disabled="fileMessage == '上传中'"
            v-model="form.data"
            max-count="3"
            :after-read="afterImgRead"
          />
        </el-form-item>
        <!-- 资料盒子结束 -->
        <!-- 签名 -->
        <el-form-item label="签名" prop="imgData" class="form-item">
          <div v-if="form.imgData" class="resign">
            <div style="width: 50px">
              <img class="sign-img" :src="form.imgData" />
            </div>
            <span @click="showPopup" class="resign-txt">重新签名</span>
          </div>
          <el-button v-else class="sign-btn" @click="showPopup">
            <span class="img"></span>签名
          </el-button>
        </el-form-item>
        <!-- 签名结束 -->
      </el-form>
      <!-- form结束 -->
    </div>
    <!-- 按钮框 -->
    <div class="sure-box" @click="onSubmit" v-if="bottomShow&&
            !(configuration.limitFlag == 1 && configuration.limitCount == 0)">
      <span>{{ isOk }}</span>
    </div>
    <!-- 按钮框结束 -->
  </div>
</template>
<script>
import { toast } from "@/common/api/api.js";
import { comfortApply, signinHonoreeSignature, getWXInfo,getApprovalCountByUserId } from "@/common/api";
import signature from "../../../components/signature.vue";
import topPart from "../../../components/topPart";
export default {
  name: "condoleApply",
  components: {
    signature,
    topPart,
  },
  data() {
    return {
      configuration: {},
      isOk: "确定", //按钮文字
      isOkFlag: false, //按钮标识
      rules: this.centralControl.check.getCheckConfig("subsidy"),
      comfortType: "", //类型
      loading: false,
      fileCount: 0,
      applyMoneyCopy: 0, //校验
      fileList: [],
      form: {
        data: [], //图片盒子
        gender: "", //性别
        age: "", //年龄
        name: "请选择慰问人员的姓名", //申请人姓名
        deptName: "", //科室名称
        unionName: "", //分会名称
        desc: "", //申请原因和现状
        nameId: "", // 申请人ID
        applyMoney: "", //申请金额
        imgData: "", //签名
      },
      test: false,
      loginInfo: "",
      validateData: [
        { item: "nameId", code: "申请人不能为空" },
        { item: "imgData", code: "请签名,不能为空" },
        { item: "desc", code: "申请原因及现状不能为空" },
      ],
      docmHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      showHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      bottomShow: true,
      maxSize: 5,
      fileMessage: "",
    };
  },
  created() {
    var config = this.centralControl.utils.getConfig(
      this.centralControl.config,
      ["sympathy", "subsidy"]
    );
    //设置类型
    this.comfortType = config.type;

    this.loginInfo = JSON.parse(window.localStorage.getItem("loginInfo"));
    let selPerson = this.$route.query.person;
    if (selPerson) {
      this.form.name = selPerson.name || "请选择慰问人员的姓名";
      this.form.deptName = selPerson.deptName;
      this.form.unionName = selPerson.unionName;
      this.form.nameId = selPerson.id;
      this.form.age = selPerson.age;
       this.getApprovalCountByUserId(selPerson.id);
      if (selPerson.sex == "男") {
        this.form.gender = "1";
      } else if (selPerson.sex == "2") {
        this.form.gender = "2";
      } else if (selPerson.sex == "1") {
        this.form.gender = "1";
      } else {
        this.form.gender = "";
      }
    }else {
      this.getApprovalCountByUserId(this.loginInfo.id);
    }
  },
  watch: {
    showHeight: function () {
      if (this.docmHeight > this.showHeight) {
        //隐藏
        this.bottomShow = false;
      } else {
        //显示
        this.bottomShow = true;
      }
    },
  },

  mounted() {
    window.onresize = () => {
      return (() => {
        this.showHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
      })();
    };
  },

  methods: {
    getApprovalCountByUserId(id) {
      var obj = {
        comfortType: this.comfortType,
        staffId: id,
      };
      getApprovalCountByUserId(obj).then((res) => {
        if (res.code == 200) {
          this.configuration = res.data;
        }
      });
    },
    onOversize() {
      toast(this, `文件大小不能超过${this.maxSize}M`, "error");
    },
    // 上传完图片的时的钩子函数
    afterImgRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      this.fileMessage = "上传中";
      var obj = { file: this.form.data[this.fileCount].file };
      this.centralControl.axios.centralControl(
        "uploadFile",
        (res) => {
          const { data = {}, code, message } = res;
          if (code == "200") {
            file.status = "success";
            file.message = "上传成功";
            this.fileMessage = "上传成功";
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        },
        obj
      );
      console.log(file);
    },
    transfromsex(sex) {
      if (sex == "2") {
        return "女";
      } else if (sex == "1") {
        return "男";
      } else {
        return "";
      }
    },
    fileUpload() {
      var obj = { file: this.form.data[this.fileCount].file };
      this.centralControl.axios.centralControl(
        "uploadFile",
        (res) => {
          const { data = {}, code, message } = res;
          if (code == "200") {
            const { fileKey } = data;
            this.fileList.push(fileKey);
            this.fileCount = this.fileCount + 1;
            this.submit();
          }
        },
        obj
      );
    },
    changgeNumber() {
      this.form.applyMoney = this.form.applyMoney.replace(/\s+/g, "");
      if (this.form.applyMoney.indexOf(".") != -1) {
        this.form.applyMoney = this.form.applyMoney.substring(
          0,
          this.form.applyMoney.indexOf(".") + 3
        );
      }

      if (!isNaN(this.form.applyMoney)) {
        this.applyMoneyCopy = this.form.applyMoney;
      } else {
        this.form.applyMoney = this.applyMoneyCopy;
      }
    },
    validate() {
      let obj = { flag: true };
      for (let a = 0; a < this.validateData.length; a++) {
        if (!this.form[this.validateData[a].item]) {
          obj.flag = false;
          obj.token = a;
          return obj;
        }
      }
      return obj;
    },

    submit() {
      if (this.isOkFlag) {
        toast(this, "提交中请稍等", "error");
        return;
      }
      if (this.fileCount < this.form.data.length) {
        this.fileUpload();
      } else {
        this.loading = true;
        var obj = {
          handle: this.loginInfo.id,
          nameId: this.form.nameId,
          comfortType: this.comfortType,
          reason: this.form.desc,
          money: this.form.applyMoney,
          applierSign: this.form.imgData,
          name: this.loginInfo.name,
          company: this.loginInfo.unionName,
          sex: this.form.gender, //性别
          age: this.form.age, //年龄
          fileList: JSON.stringify(this.fileList),
          unionId: this.loginInfo.unionId,
        };
        this.isOkFlag = !this.isOkFlag;
        this.isOk = "提交中...";
        this.centralControl.axios.centralControl(
          "addSympathy",
          (res) => {
            this.loading = false;
            if (res.code == 200) {
              toast(this, "提交成功");
              this.$router.push({
                path: "/subsidy",
              });
            } else {
              this.isOk = "确定"; //按钮文字
              this.isOkFlag = false; //按钮标识
              toast(this, res.message, "error");
            }
          },
          obj
        );
      }
    },

    onSubmit() {
      if (this.form.nameId == "") {
        toast(this, "申请人不能为空");
        return;
      }
      if (this.form.imgData == "") {
        toast(this, "请签名,不能为空");
        return;
      }
      if (this.form.applyMoney == "") {
        toast(this, "申请补助金额不能为空");
        return;
      }
      if (this.form.desc == "") {
        toast(this, "申请原因及现状不能为空");
        return;
      }
      if (this.form.desc.length < 2 || this.form.desc.length > 200) {
        toast(this, "申请原因及现状应该在2到200字符之间");
        return;
      }
      // if (this.form.data.length < 1) {
      //   toast(this, "请上传资料");
      //   return;
      // }
      this.fileCount = 0; //计时器归零
      this.fileList = [];
      if (!this.form.data[this.fileCount]) {
        this.submit();
      } else {
        this.fileUpload();
      }
    },
    cancel() {
      this.form.nameId = "";
      this.form.name = "";
      this.form.deptName = "";
      this.form.unionName = "";
      this.form.desc = "";
      this.form.imgData = "";
    },
    //人员管理
    openPersonnel() {
      this.$router.push({
        path: "/sympathyManagement",
        query: {
          router: "/subsidyApply",
          status: 1, // 1 选择人员
        },
      });
    },
    myCondole() {
      this.$router.push("/myCondole");
    },
    complete(data) {
      if (data) {
        this.form.imgData = data;
        this.test = false;
      }
      this.bottomShow = true;
    },
    showPopup() {
      this.test = !this.test;
      this.bottomShow = false;
    },
    closePop() {
      this.test = false;
      this.bottomShow = true;
    },
    handleBlur() {
      document.activeElement.blur();
    },
  },
};
</script>

<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/theme.styl';
@import '../../../assets/stylus/common.styl';

.imgStyle {
  width: 100%;
}

.apply-content-box {
  myContent();
  bottom: 74px;
}

.right-icon {
  font-size: 16px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  line-height: 38px;
}

.sure-box {
  height: 44px;
  background: rgba(41, 190, 188, 1);
  border-radius: 5px;
  line-height: 44px;
  color: #fff;
  width: 90%;
  text-align: center;
  margin: 0 auto 0;
  position: fixed;
  bottom: 15px;
  left: 0;
  right: 0;
}

.height {
  color: #38c7c4;
}

.startStyleBox {
  display: flex;
  justify-content: flex-end;
}

.noheight {
  color: red;
}

.imgStyleBox {
  width: 30%;
  position: absolute;
  top: 15%;
  right: 15%;
}

.sign {
  #wrapper {
    .rewrite {
      right: 0 !important;
      left: 50% !important;
      top: -60%;
      transform: rotate(270deg) translateY(-50%) !important;
    }
  }
}

.el-form {
  .el-textarea .el-input__count {
    line-height: 13px;
    font-size: 12px;
  }

  .overflowText {
    .el-form-item__label {
      line-height: 24px;
      text-align: center !important;
    }
  }

  .sign {
    .el-form-item__label {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .resign {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .sign-img {
      width: 60px;
      height: 60px;
      transform: rotate(90deg);
    }

    .resign-txt {
      font-style: normal !important;
    }
  }

  .form-item {
    background: #fff;
    padding: 10px 20px;
    margin-bottom: 0;
    border-bottom: 1px solid #f4f4f4;
    position: relative;

    .el-form-item__label {
      text-align: left;
      width: 70px !important;
    }

    .el-form-item__content {
      margin-left: 70px !important;
    }

    .input {
      .el-input__inner {
        border: none;
        padding: 0;
      }
    }

    .input-sel {
      width: calc(100% - 40px);
    }

    .sel-txt, .resign-txt {
      color: $default-color;
      font-size: 12px;
      font-style: italic;
      display: inline-block;
      text-align: center;
    }

    .sign-btn {
      width: 100%;
      color: #38c7c4;
      border-color: $default-color;
      background-color: #fff;

      .img {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url('/img/icon-sign.00caefc8.png') no-repeat center center;
        background-size: 100% 100%;
        vertical-align: middle;
        margin-right: 5px;
      }
    }

    .el-radio-group {
      font-size: 0;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 40px;
      line-height: 40px;
    }

    .el-radio {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
    }
  }

  .submit-btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    margin-bottom: 0;
    padding: 10px 0;
    text-align: center;
    border-top: 1px solid $border-color;
    font-size: 18px;
    background: #fff;

    .el-form-item__content {
      margin-left: 0 !important;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
    }

    .el-button--primary {
      color: #FFF;
      background-color: $default-color;
      border-color: $default-color;
      width: 150px;
      height: 44px;
      background: $default-color;
      border-radius: 5px;
      font-size: 18px;
    }

    .btn-cancel {
      background-color: #fff;
      color: $default-color;
    }
  }

  .el-radio__original, .el-radio__input, .el-radio__inner {
    width: 23px;
    height: 23px;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: $default-color;
    background: $default-color;
    width: 23px;
    height: 23px;
  }

  .el-radio__inner::after {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../assets/images/sel-checked.png') no-repeat center center;
    background-size: 100% 100%;
    vertical-align: middle;
    margin-right: 5px;
  }

  .el-radio__input.is-checked+.el-radio__label {
    color: $default-color;
  }

  .el-textarea__inner:focus {
    border-color: $default-color;
  }
}
</style>